import { defineStore } from 'pinia'

export const ShowDevVields = defineStore({
    id: 'mr_dev__fields',
    state: () => {
        return { value: false }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})